import { useTranslation } from 'react-i18next'

import { fmtDate } from '../../utils/fmtDate'
import styles from './StatementsList.module.scss'

const StatementsList = ({ list, onOpen }) => {
  const { t } = useTranslation('common')

  return (
    <div className={`unv-card ${styles.tableWrap}`}>
      <table className="unv-table">
        <thead>
          <tr>
            <th>{t('statementsPage.discipline')}</th>
            <th>{t('statementsPage.group')}</th>
            <th>{t('statementsPage.semester')}</th>
            <th>{t('statementsPage.type')}</th>
            <th>{t('statementsPage.status')}</th>
            <th>{t('statementsPage.createdAt')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list.map((s) => (
            <tr key={s.id}>
              <td>{s.subject_name || s.subject?.name || '—'}</td>
              <td>{s.group_name || s.group?.name || '—'}</td>
              <td>{s.semester_name || s.semester || '—'}</td>
              <td>{s.kind || s.type || '—'}</td>
              <td><span className="unv-badge">{s.status}</span></td>
              <td>{fmtDate(s.created_at)}</td>
              <td>
                <button className="unv-btn" onClick={() => onOpen(s)}>
                  {t('statementsPage.open')}
                </button>
              </td>
            </tr>
          ))}
          {list.length === 0 && (
            <tr>
              <td colSpan="7" className={styles.empty}>{t('statementsPage.noStatements')}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default StatementsList
